import React from 'react';

// Shared two-(or-more)-segment toggle. Extracted for the Customer Specs UPC
// Catalog/Custom switch (manual UPC plan); the form-ux plan migrates the existing
// hand-rolled toggles (Entry Form header + Manage drawer scope) onto it.
//
// tone='light' (default) sits on a light surface (form body): neutral container,
// muted inactive text. tone='dark' sits on the green page header: translucent-white
// container, cream inactive text. Tokens only — no raw color literals.
const SegmentedToggle = ({
  options = [],
  value,
  onChange,
  ariaLabel,
  size = 'md',
  tone = 'light',
  disabled = false,
}) => {
  const pad = size === 'sm' ? '5px 12px' : '6px 14px';
  const fontSize = size === 'sm' ? '0.85rem' : '0.95rem';
  const containerBg = tone === 'dark' ? 'var(--white-a20)' : 'var(--shadow-a08)';
  const inactiveColor = tone === 'dark' ? 'var(--cream-400)' : 'var(--shadow-a65)';

  return (
    <div
      role="group"
      aria-label={ariaLabel}
      style={{
        display: 'inline-flex',
        background: containerBg,
        borderRadius: 10,
        padding: 4,
        boxShadow: 'inset 0 1px 2px var(--shadow-a15)',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {options.map((opt) => {
        const active = String(opt.value) === String(value);
        return (
          <button
            key={String(opt.value)}
            type="button"
            aria-pressed={active}
            disabled={disabled}
            onClick={() => { if (!disabled && !active) onChange?.(opt.value); }}
            style={{
              border: 'none',
              cursor: disabled ? 'default' : 'pointer',
              padding: pad,
              borderRadius: 8,
              fontSize,
              fontWeight: 600,
              fontFamily: 'inherit',
              background: active ? 'var(--white)' : 'transparent',
              color: active ? 'var(--color-text)' : inactiveColor,
              boxShadow: active ? '0 2px 6px var(--shadow-a25)' : 'none',
              transition: 'all 120ms ease',
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedToggle;
